/**
 * Calls the arbitium/s3_extract handler.
 * Streams and returns the parsed content of a file stored in S3.
 */

import { ARBITIUM_EXTENSION, callHandler, type HandlerCallResponse } from '../core';

export type S3ExtractResult = Omit<HandlerCallResponse, 'output'> & {
  output?: Array<Record<string, unknown>>;
};

/**
 * Fetches and returns the parsed content of an S3 file via the s3_extract handler.
 * @param s3FileUrl  e.g. 's3://my-bucket/candidates/aws/file.json'
 */
export async function extractS3File(s3FileUrl: string): Promise<S3ExtractResult> {
  const res = await callHandler(ARBITIUM_EXTENSION, 's3_extract', { s3_file_url: s3FileUrl });
  return res as S3ExtractResult;
}
